<template>
  <div
    class="real-time lg:max-w-4xl mx-auto w-full font-body-medium font-medium sm:font-body-large text-gray-2"
  >
    <div class="px-6 mb-8 text-center">
      <SectionHeader class="mb-2">Employee Voices</SectionHeader>
      <p>
        Every employee deserves to be heard so we built a real time chat service
        designed for employees to interact with your HR manager. The service is
        built into the Bambee platform making it easy to deploy and&nbsp;use.
      </p>
    </div>

    <div class="grid grid-cols-12 max-w-4xl mx-auto mb-8">
      <div
        v-for="(item, index) in voiceBox"
        :key="`voice-box-${index}`"
        class="voice-box col-span-12 flex flex-col text-center mb-6 mx-auto p-2 sm:col-span-4 sm:mb-0"
        style="max-width: 200px"
      >
        <HighlightedIcon :icon="item.icon" class="mb-4 mx-auto" size="large" />
        <TypeBody
          :variant="$options.constants.Typography.Body.LARGE"
          :weight="$options.constants.Typography.Weights.STRONG"
          >{{ item.text }}</TypeBody
        >
      </div>
    </div>

    <SlideShowEmployeeChat />
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import { TypeBody, HighlightedIcon, constants } from '@bambeehr/pollen';
import SectionHeader from '@/components/SectionHeader.vue';
import SlideShowEmployeeChat from '@/modules/InformationPages/Product/components/Media/SlideShowEmployeeChat';

export default defineComponent({
  name: 'SplashEmployeeVoices',
  constants,
  components: {
    TypeBody,
    HighlightedIcon,
    SectionHeader,
    SlideShowEmployeeChat,
  },
  setup() {
    const voiceBox = [
      {
        icon: 'clipboardCheckSolid',
        text: 'Objective & Professional',
      },
      {
        icon: 'clipboardCheckSolid',
        text: 'Facilitate Transparency & Resolve Conflict',
      },
      {
        icon: 'clipboardCheckSolid',
        text: 'Enable A Thriving Workplace',
      },
    ];

    return {
      voiceBox,
    };
  },
});
</script>
